import React from 'react'

import { DEFAULT_TABLE_PROPS } from '../../constants'
import useHeaderFooterStyles from '../../styles/useHeaderFooterStyles'
import { VirtuosoTableHeadProps } from './virtuoso-table-sections'

const VirtuosoTableHead = React.forwardRef<
  HTMLTableSectionElement,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  VirtuosoTableHeadProps<any>
>(({ tableProps, scrolled, ...props }, ref) => {
  const { cx, classes } = useHeaderFooterStyles({
    tableFontSize: tableProps?.fontSize ?? DEFAULT_TABLE_PROPS.fontSize,
  })

  return (
    <thead
      {...props}
      className={cx(classes.header, {
        [classes.scrolled]: Boolean(scrolled),
      })}
      ref={ref}
    ></thead>
  )
})

VirtuosoTableHead.displayName = 'VirtuosoTableHead'
export default VirtuosoTableHead
